<template>
  <div>
    <v-row class="pa-0 mb-n11">
      <v-col cols="9" class="d-flex flex-row">
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="getSelectedTaxType" label="Tax Type" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="editedItem.taxYear" label="Tax Year" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2"
        :value="editedItem.taxId" label="Tax ID" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2" label="Base ID"
      :value="editedItem.baseId" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      v-model="editedItem.ownerId" label="Owner ID" :rules="rulesForNumerics" />
      <v-btn v-if="showLoadInfo" small color="primary" class="ml-2 align-self-center"
       :loading="loadingOwnerInfo" @click="loadOwnerInfo">Load Info</v-btn>
    </v-col>
    <v-col cols="3">
      <v-text-field class="input-text-size pt-0 pb-0" v-model="editedItem.propertyOrParcelId"
        label="Property/Parcel ID" readonly tabindex="-1" />
    </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0 mt-n1"
         :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
         label="Name 1" v-model="editedItem.name1" :rules="rules"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         :readonly="checkTheUserIsTaxAdmin" :tabindex="checkTheUserIsTaxAdmin ? -1 : 0"
         label="Name 2" v-model="editedItem.name2"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Address 1" v-model="editedItem.address1" :rules="addressRules"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Address 2" v-model="editedItem.address2"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Address 3" v-model="editedItem.address3"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Address 4" v-model="editedItem.address4"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-row>
          <v-col cols="4">
            <v-text-field class="input-text-size pa-0 mt-n1"
             label="City" v-model="editedItem.city"
             v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pa-0 mt-n1"
             label="State" v-model="editedItem.state"
             v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pa-0 mt-n1"
             label="Zip" v-model="editedItem.zip"
             @blur="zipFormatter('zip')" :value="formattedValues.zip"
             @focus="(e) => { zipUnformatter(e, 'zip') }" />
          </v-col>
        </v-row>
      <v-text-field class="input-text-size pa-0 mt-n1" label="Country" v-model="editedItem.country"
       v-uppercase=globalSettingItem.conEverythingToCaps />
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="In Care of 1" v-model="editedItem.inCareOf1"
         :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="In Care of 2" v-model="editedItem.inCareOf2"
         :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
         maxlength="40" counter="40"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Email Address" v-model="editedItem.emailAddess"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Primary Phone" v-model="editedItem.primaryPhone" />
        <v-textarea class="input-text-size pa-0  mt-n1 dec-line-height" outlined rows="11"
         label="Owner Info Consolidated View" :value="handleConsolidateView()"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { zipDeFormat, zipFormat } from '../../../../util/shared/vue-global';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import InCareOfSetting from '../../common-utils/inCareOf.mixin';
import { commonFuncForConsolidateView } from '../../common-utils/tax-common.util';
import { REGEX_VALIDATION } from '../../common-utils/constants';
import '../../../../assets/style.css';

export default {
  mixins: [GlobalToCaps, InCareOfSetting],
  data() {
    return {
      formattedValues: {
        zip: '',
      },
      loadingOwnerInfo: false,
      originalOwnerId: null,
    };
  },
  mounted() {
    this.zipFormatter('zip');
  },
  watch: {
    'editedItem._id': {
      immediate: true,
      handler() {
        // capture the record's saved ownerId so the button only shows on change
        this.originalOwnerId = this.editedItem.ownerId;
      },
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapGetters('auth/token', [
      'isTaxAdminAccessible',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    showLoadInfo() {
      // show only when owner id changed and both taxYear + ownerId are present
      return !!this.editedItem.taxYear && !!this.editedItem.ownerId
        && String(this.editedItem.ownerId) !== String(this.originalOwnerId);
    },
    rules() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    rulesForNumerics() {
      return [
        (v) => {
          if (v) return REGEX_VALIDATION.onlyNumWithSomeSpeChar.test(v) || 'Numerics only';
          return !!v || 'Required.';
        },
        () => true,
      ];
    },
    addressRules() {
      return [
        // if any address field is filled no need to validate
        (v) => (!!v || !!this.editedItem.address2 || !!this.editedItem.address3 || !!this.editedItem.address4) || 'Required.',
        () => true,
      ];
    },
    checkTheUserIsTaxAdmin() {
      const userRole = this.isTaxAdminAccessible;
      return (!userRole && !!this.editedItem._id);
    },
    getSelectedTaxType() {
      const selVal = (this.TaxTypeEnum || []).find((ft) => ft.name === this.editedItem.taxType);
      if (selVal && selVal.name) return `${selVal.name} - ${selVal.description}`;
      return '';
    },
  },
  props: {
    selectedRowItem: {
      type: Object,
      default: () => {},
    },
    baseCrudKey: {
      type: String,
      default: 'TaxInquiryDialog',
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    ...mapActions('tax/taxInquires', [
      'getTaxInquires',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    async loadOwnerInfo() {
      const { taxYear, ownerId } = this.editedItem;
      if (!ownerId) return;
      this.loadingOwnerInfo = true;
      try {
        const criteria = {
          limit: 1,
          skip: 0,
          taxYear: taxYear || 0,
          ownerNumber: String(ownerId),
        };
        const retRes = await this.getTaxInquires({ criteria });
        if ((retRes || []).length) {
          const res = retRes[0];
          const ownerFields = ['name1', 'name2', 'address1', 'address2', 'address3', 'address4',
            'city', 'state', 'zip', 'country', 'inCareOf1', 'inCareOf2', 'emailAddess', 'primaryPhone'];
          // Load Info fills the form from another owner's record with no typing, so on a county
          // with the setting on it would put text into a locked box. Leave this record's own
          // In Care Of exactly as it is.
          const fieldsToCopy = this.disableInCareOfFields
            ? ownerFields.filter((ft) => ft !== 'inCareOf1' && ft !== 'inCareOf2')
            : ownerFields;
          fieldsToCopy.forEach((ft) => { this.editedItem[ft] = res[ft] || ''; });
          this.zipFormatter('zip');
        } else {
          this.custumColrFlashMsg({ msg: 'Owner record not found' });
        }
      } finally {
        this.loadingOwnerInfo = false;
      }
    },
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    handleConsolidateView() {
      return commonFuncForConsolidateView(this.editedItem);
    },
    zipUnformatter(e, val) {
      const formatedAmt = zipDeFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
      // settimout is required to make it select after the zip state is set
      setTimeout(() => e.target.select(), 50);
    },
    zipFormatter(val) {
      const formatedAmt = zipFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
    },
  },
};
</script>
